module.exports = __webpack_public_path__ + "img/工业制冷云平台1.7b7a62ae.png";